module.exports = __webpack_public_path__ + "static/media/avatar_19.58495dd7.svg";